import { render, staticRenderFns } from "./ObiNotification.vue?vue&type=template&id=28c6a67e&scoped=true&"
import script from "./ObiNotification.vue?vue&type=script&lang=js&"
export * from "./ObiNotification.vue?vue&type=script&lang=js&"
import style0 from "./ObiNotification.vue?vue&type=style&index=0&id=28c6a67e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c6a67e",
  null
  
)

export default component.exports